import CbFormGroup from './src/form-group.vue';

CbFormGroup.install = function(Vue) {
  Vue.component(CbFormGroup.name, CbFormGroup);
};

export default CbFormGroup;
